<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ 'Award Sales Invoices' | translate }}</h4>
</div>
<div class="modal-body">
  <div [innerHTML]="'Awarding_invoices_dialog_content' | translate"></div>
  <ng-container *ngIf="!enableInvitePartner">
    <select #userSelect (change)="selectedUser(userSelect.value)" style="height: 50px; width: 100%">
      <option value="0" disabled>{{ 'Choose team member' | translate }}</option>
      <option *ngFor="let user of activeNonPrcUsers" [value]="user.email">
        {{ user.email }}
      </option>
    </select>
  </ng-container>
  <ng-container *ngIf="enableInvitePartner">
    <app-user-email-typeahead
      [users]="activeNonPrcUsers"
      [placeholder]="'Choose team member'"
      (valueChange)="selectedUser($event)"
    ></app-user-email-typeahead>
    <div *ngIf="enableInvitePartner && destinationUserEmail">
      <div class="mt-3 confirm-email" [innerHTML]="invitePartnerSection | safeHtml"></div>
      <input
        #inputEl
        id="email-confirmation"
        type="email"
        class="form-control"
        (input)="onInput(inputEl.value)"
        [placeholder]="'Email address' | translate"
      />
    </div>
  </ng-container>
</div>
<div class="modal-footer">
  <button class="btn btn-primary btn-search py-2" (click)="awardInvoice()">
    {{ buttonLabel | translate }}
  </button>
  <button class="btn btn-primary btn-search py-2" (click)="onCancel(false)">{{ 'Close' | translate }}</button>
</div>
